import { Parser } from "../../../../helpers/parser";
import localScaleManager from "../../../../helpers/LocalScaleManager";
import { tweenConfigs } from "../../../../helpers/tweensConfigs";

export class PotParent {
  constructor(scene, value, table, chipsTexture, chipTexture) {
    this.scene = scene;
    this.table = table;
    this.value = value;
    this.chipsTexture = chipsTexture;
    this.chipTexture = chipTexture;

    // this.textBox = this.scene.add
    //   .image(0, 0, this.scene.atlasTexture, "chip-text-box")
    //   .setOrigin(0);
    // this.table.poolArray.push(this.textBox);

    this.text = this.scene.add.bitmapText(
      0,
      0,
      "HelveticaNeue",
      Parser.convertToXLetters(Parser.toCurrency(888888), 8)
    );
    this.table.poolArray.push(this.text);

    this.text.setData("width", this.text.width);
    this.text.setData("height", this.text.height);

    this.chips = this.scene.add
      .image(0, 0, this.scene.atlasTexture, this.chipsTexture)
      .setOrigin(0);
    this.table.poolArray.push(this.chips);

    this.chip = this.scene.add
      .image(0, 0, this.scene.atlasTexture, this.chipTexture)
      .setOrigin(0)
      .setVisible(false);
    this.table.poolArray.push(this.chip);

    this.winChipsCount = 3;
    this.winPotTweenDelay = 0;
    this.winPotTweenDelayCalculated = false; /* We need to calculate win pot tween delay once */
    this.createWinChips();
  }
  visibilityControls(visibility) {
    // if (this.textBox.visible !== visibility)
    //   this.textBox.setVisible(visibility);
    if (this.chips.visible !== visibility) this.chips.setVisible(visibility);
    if (this.text.visible !== visibility) this.text.setVisible(visibility);
  }

  /**
   * @param value {number} pat value
   * Parser.toCurrency(value) for handling numbers upper than 1M e.g. 11895413 => 11,895k
   * Parser.convertToXLetters(value ,count) for putting spaces around final string in order to align it in the center
   */
  changeText(value) {
    this.value = value;
    const potDemo = Parser.convertToXLetters(Parser.toCurrency(this.value), 8);
    this.text.setText(potDemo);
    const textX = this.chips.x + (this.chips.displayWidth - this.text.width) / 2;
    if(this.text.x !== textX) this.text.setX(textX);
  }
  goToWinners(winners) {
    let tweenCounter;
    // // console.log(winners);
    // winners.push(Object.assign({},winners[0] ));
    // winners.push(Object.assign({},winners[0] ));
    // winners.push(Object.assign({},winners[0] ));
    // winners[0].position = 1;
    // winners[1].position = 2;
    // winners[2].position = 3;
    // winners[3].position = 4;
    const chipsForEveryWinner = Math.trunc(this.winChipsCount / winners.length);
    this.resetWinChipsXY();
    // this.visibilityControls(false);
    this.setWinPotTweenDelay();
    winners.forEach((winner, j) => {
      const winnerSeat = this.table.findSeatByPosition(winner.position);
      tweenCounter = 0;
      if (this.scene.tweenEnable) {
        this.winChipsGroup.children.iterate(function (child, i) {
          if (
            chipsForEveryWinner * j <= i &&
            i < chipsForEveryWinner * (j + 1)
          ) {
            tweenCounter++;
            this.scene.tweens.add({
              targets: child,
              x: winnerSeat.box.x,
              y: winnerSeat.box.y,
              alpha: {
                value: 0,
                delay: 500,
              },
              // ease: "Sine.easeInOut",
              ease: tweenConfigs.winChips.ease,
              duration: tweenConfigs.winChips.duration,
              delay:
                (i + 1) * tweenConfigs.winChips.delay + this.winPotTweenDelay,
              onComplete: () => {
                if (child.visible) child.setVisible(false);
                child.alpha = 1;
                // tweenCounter++;
                // if (tweenCounter === chipsForEveryWinner) {
                //   winnerSeat.winAmount.show();
                // Phaser.Actions.SetVisible(this.winChipsGroup.getChildren(), false);
                // }
              },
              onStart: () => {
                if (i === 0 && j === 0) {
                  Phaser.Actions.SetVisible(
                    this.winChipsGroup.getChildren(),
                    true
                  );
                  if (this.winChipsCount % winners.length !== 0) {
                    for (
                      let k = 0;
                      k < this.winChipsCount % winners.length;
                      k++
                    ) {
                      this.winChipsGroup
                        .getChildren()
                        [this.winChipsCount - (k + 1)].setVisible(false);
                    }
                  }
                  this.visibilityControls(false);
                }
                if (i === 0) {
                  this.table.sounds.play("win-chips");
                }
              },
            });
          }
        }, this);
      } else {
        this.visibilityControls(false);
        winnerSeat.winAmount.show();
      }
    });
  }
  setWinPotTweenDelay() {
    if (!this.winPotTweenDelayCalculated) {
      const playerBet = this.table.playerSeats[0].playerBet;
      this.winPotTweenDelay =
        playerBet.stackChipsTweenDuration + playerBet.stackChipsTweenDelay;
      this.winPotTweenDelayCalculated = true;
    }
  }
  createWinChips() {
    this.winChipsGroup = this.scene.add.group({
      key: this.scene.atlasTexture,
      frame: this.chipTexture,
      repeat: this.winChipsCount - 1,
      setScale: { x: this.chip.scaleX, y: this.chip.scaleY },
      // setXY: { x: this.chip.x, y: this.chip.y},
      setOrigin: { x: 0, y: 0 },
    });
    this.table.poolArray.push(this.winChipsGroup);
    this.table.poolArray.push(...this.winChipsGroup.getChildren());
    Phaser.Actions.SetX(this.winChipsGroup.getChildren(), this.chip.x);
    Phaser.Actions.PropertyValueInc(
      this.winChipsGroup.getChildren(),
      "y",
      this.chip.y,
      1
    );
    // this.winChipsGroup.propertyValueInc('y', this.chip.y, 10, 0, 1);
    Phaser.Actions.SetVisible(this.winChipsGroup.getChildren(), false);
    Phaser.Actions.SetDepth(this.winChipsGroup.getChildren(), 11);
  }
  resetWinChipsXY() {
    Phaser.Actions.SetX(this.winChipsGroup.getChildren(), this.chip.x);
    Phaser.Actions.SetY(this.winChipsGroup.getChildren(), 0);
    Phaser.Actions.PropertyValueInc(
      this.winChipsGroup.getChildren(),
      "y",
      this.chip.y,
      1
    );
  }
  // handleVisibilityChange(hidden) {
  //   let activeTweens;
  //   if (hidden) {
  //     /* agar game hidden shod va active tween dashtim bayad hame ra foran b payan bbarim
  //      * ba tavajoh b inke agr tweeni k montazer etmam delay ast ra seek konim onStart on tween ejra nemishavad
  //      */
  //     activeTweens = this.scene.tweens.getTweensOf(
  //       this.winChipsGroup.getChildren()
  //     );
  //     if (activeTweens.length) {
  //       this.visibilityControls(false);
  //       Phaser.Actions.SetVisible(this.winChipsGroup.getChildren(), true);
  //     }
  //     activeTweens.forEach((tween) => {
  //       tween.complete();
  //     });
  //     Phaser.Actions.SetVisible(this.winChipsGroup.getChildren(), false);
  //   }
  // }
  /***
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  positionControls(width, height, initX, initY) {
    localScaleManager.scaleSprite(
      this.chips,
      width / 17,
      width / 17,
      0,
      1,
      true
    );
    localScaleManager.scaleSprite(
      this.chip,
      width / 20,
      width / 20,
      0,
      1,
      true
    );
    localScaleManager.scaleBitMapText(
      this.text,
      width,
      this.chip.displayHeight * 0.75,
      Math.min(this.text.width, this.text.height) * 0.2,
      1,
      false
    );

    // localScaleManager.scaleSprite(
    //   this.textBox,
    //   width * 0.14,
    //   width * 0.14,
    //   0,
    //   1,
    //   true
    // );
    Phaser.Actions.SetScale(
      this.winChipsGroup.getChildren(),
      this.chip.scaleX,
      this.chip.scaleY
    );
  }
  /***
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  reposition(width, height, initX, initY) {}
  removeParent() {
    this.chips.destroy();
    this.chip.destroy();
    this.text.destroy();
    // this.textBox.destroy();
  }
}
